import { render, staticRenderFns } from "./BtnEditRates.vue?vue&type=template&id=16c63c73&scoped=true"
import script from "./btnEditRates.ts?vue&type=script&lang=ts&external"
export * from "./btnEditRates.ts?vue&type=script&lang=ts&external"
import style0 from "./BtnEditRates.vue?vue&type=style&index=0&id=16c63c73&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c63c73",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16c63c73')) {
      api.createRecord('16c63c73', component.options)
    } else {
      api.reload('16c63c73', component.options)
    }
    module.hot.accept("./BtnEditRates.vue?vue&type=template&id=16c63c73&scoped=true", function () {
      api.rerender('16c63c73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/explore/btn-edit-rates/BtnEditRates.vue"
export default component.exports